// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.question-page {
  min-height: 100vh;
  width: 100%;
  display: flex;
  flex-direction: column;
  background: linear-gradient(to bottom, #e8f5e9 0%, #c8e6c9 100%);
}

.question-page-content {
  flex: 1 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 2rem;
  min-height: calc(100vh - 200px); /* Adjust based on NavBar and Footer height */
  gap: 2rem;
}

/* Expand the text-input-section to take full width with appropriate max-width */
.question-page-content .text-input-section {
  width: 100%;
  max-width: 1200px;
  padding: 0;
}

/* Expand the input-container for better full-page experience */
.question-page-content .input-container {
  max-width: 100%;
  padding: 2rem;
  min-height: 500px;
  display: flex;
  flex-direction: column;
}

/* Make textarea larger for full-page */
.question-page-content .text-area {
  width: 100% !important;
  height: 300px;
  min-height: 300px;
  padding: 1rem;
}

/* Enhance question display for full-page */
.question-page-content .question-display {
  margin-bottom: 2rem;
  padding: 1.5rem;
}

.question-page-content .question-text {
  font-size: 1.25rem;
  line-height: 1.8;
}

/* Responsive design */
@media (max-width: 768px) {
  .question-page-content {
    padding: 1rem;
    min-height: calc(100vh - 150px);
  }

  .question-page-content .input-container {
    padding: 1.5rem;
    min-height: 400px;
  }

  .question-page-content .text-area {
    height: 250px;
    min-height: 250px;
  }

  .question-page-content .question-text {
    font-size: 1.1rem;
  }
}

@media (max-width: 480px) {
  .question-page-content {
    padding: 0.75rem;
  }

  .question-page-content .input-container {
    padding: 1rem;
    min-height: 350px;
  }

  .question-page-content .text-area {
    height: 200px;
    min-height: 200px;
  }
}

`, "",{"version":3,"sources":["webpack://./src/unAuth/QuestionPage.css"],"names":[],"mappings":"AAAA;EACE,iBAAiB;EACjB,WAAW;EACX,aAAa;EACb,sBAAsB;EACtB,gEAAgE;AAClE;;AAEA;EACE,SAAO;EACP,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,+BAA+B,EAAE,6CAA6C;EAC9E,SAAS;AACX;;AAEA,gFAAgF;AAChF;EACE,WAAW;EACX,iBAAiB;EACjB,UAAU;AACZ;;AAEA,+DAA+D;AAC/D;EACE,eAAe;EACf,aAAa;EACb,iBAAiB;EACjB,aAAa;EACb,sBAAsB;AACxB;;AAEA,uCAAuC;AACvC;EACE,sBAAsB;EACtB,aAAa;EACb,iBAAiB;EACjB,aAAa;AACf;;AAEA,2CAA2C;AAC3C;EACE,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA,sBAAsB;AACtB;EACE;IACE,aAAa;IACb,+BAA+B;EACjC;;EAEA;IACE,eAAe;IACf,iBAAiB;EACnB;;EAEA;IACE,aAAa;IACb,iBAAiB;EACnB;;EAEA;IACE,iBAAiB;EACnB;AACF;;AAEA;EACE;IACE,gBAAgB;EAClB;;EAEA;IACE,aAAa;IACb,iBAAiB;EACnB;;EAEA;IACE,aAAa;IACb,iBAAiB;EACnB;AACF","sourcesContent":[".question-page {\n  min-height: 100vh;\n  width: 100%;\n  display: flex;\n  flex-direction: column;\n  background: linear-gradient(to bottom, #e8f5e9 0%, #c8e6c9 100%);\n}\n\n.question-page-content {\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  padding: 2rem;\n  min-height: calc(100vh - 200px); /* Adjust based on NavBar and Footer height */\n  gap: 2rem;\n}\n\n/* Expand the text-input-section to take full width with appropriate max-width */\n.question-page-content .text-input-section {\n  width: 100%;\n  max-width: 1200px;\n  padding: 0;\n}\n\n/* Expand the input-container for better full-page experience */\n.question-page-content .input-container {\n  max-width: 100%;\n  padding: 2rem;\n  min-height: 500px;\n  display: flex;\n  flex-direction: column;\n}\n\n/* Make textarea larger for full-page */\n.question-page-content .text-area {\n  width: 100% !important;\n  height: 300px;\n  min-height: 300px;\n  padding: 1rem;\n}\n\n/* Enhance question display for full-page */\n.question-page-content .question-display {\n  margin-bottom: 2rem;\n  padding: 1.5rem;\n}\n\n.question-page-content .question-text {\n  font-size: 1.25rem;\n  line-height: 1.8;\n}\n\n/* Responsive design */\n@media (max-width: 768px) {\n  .question-page-content {\n    padding: 1rem;\n    min-height: calc(100vh - 150px);\n  }\n\n  .question-page-content .input-container {\n    padding: 1.5rem;\n    min-height: 400px;\n  }\n\n  .question-page-content .text-area {\n    height: 250px;\n    min-height: 250px;\n  }\n\n  .question-page-content .question-text {\n    font-size: 1.1rem;\n  }\n}\n\n@media (max-width: 480px) {\n  .question-page-content {\n    padding: 0.75rem;\n  }\n\n  .question-page-content .input-container {\n    padding: 1rem;\n    min-height: 350px;\n  }\n\n  .question-page-content .text-area {\n    height: 200px;\n    min-height: 200px;\n  }\n}\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
